<template>
  <v-form v-model="valid" ref="mainForm">
    <ressource v-show="aucunEmployeur" code="aucun-employeur"></ressource>
    <v-card v-for="employeur in sas.employeurs" :key="employeur.id" outlined max-width="600" class="pa-6 mb-3">
      <div class="d-flex">
        <opq-case
          no-label
          v-model="employeur.exerciceDeLaMediationFamiliale"
          :live="{ endpoint: 'sas-cartes-affaires', cle: 2941, fileId: employeur.id }"
          optional
        ></opq-case>
        <div class="ml-3">
          <h3>{{ employeur.nomEmployeur || employeur.raisonSociale }}</h3>
          <p class="my-0">
            {{ employeur.adresse }}
          </p>
          <p class="my-0">{{ employeur.ville }}</p>
        </div>
      </div>
    </v-card>
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="aucunEmployeur || sas.employeurs.filter((e) => e.exerciceDeLaMediationFamiliale).length > 0"
      :rules="[(v) => !!v || 'Au moins une adresse professionnelle doit être sélectionnée']"
    ></v-checkbox>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasMediationFamiliale() {
      return this.sas.sasMediationFamiliale
    },
    aucunEmployeur() {
      return !this.sas.employeurs || this.sas.employeurs.length === 0
    }
  },

  methods: {
    liveSasMediationFamiliale(cle) {
      return { endpoint: "sas-mediation-familiale", cle: cle, fileId: this.sasMediationFamiliale.id }
    }
  }
}
</script>

<style>
</style>